import { render, staticRenderFns } from "./NavBarLogo.vue?vue&type=template&id=6b477bcc&scoped=true&"
import script from "./NavBarLogo.vue?vue&type=script&lang=js&"
export * from "./NavBarLogo.vue?vue&type=script&lang=js&"
import style0 from "styles/components/navbarlogo.css?vue&type=style&index=0&id=6b477bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b477bcc",
  null
  
)

export default component.exports